
export default {
  pittsTFN: {
    pageID: [
      "deposits/accounts",
      "deposits/checking-accounts",
      "deposits/interest-checking-account",
      "deposits/interest-checking-account-bya",
      "deposits/personal-checking-account",
      "deposits/personal-checking-account-bya",
      "deposits/safebalance-bank-account",
      "deposits/safebalance-bank-account-bya",
      "deposits/savings-accounts",
      "deposits/rewards-mms-bya",
      "deposits/checking-debit-cards"
    ],
    zipLow: "15001",
    zipHigh: "16263",
    phone: "800.203.9872"
  }
}
